export const COIN_DETAIL_TABS = {
  chart: '',
  markets: 'markets',
  news: 'news',
  widgets: 'widgets',
  swap: 'swap',
  // buyNow: 'buy-now'
}
